"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./modal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultModalClassName = 'Modal__Bootstrap modal-dialog ';

/** cccisd-modal provides you with bootstrap modal window */
var _default = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _default, [].concat(args));
    _defineProperty(_this, "state", {
      isOpen: false,
      loading: false
    });
    _defineProperty(_this, "open", function () {
      _this._openModal();
    });
    _defineProperty(_this, "close", function () {
      _this._handleClose();
    });
    _defineProperty(_this, "_openModal", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (_this.props.triggerDisabled) {
        return;
      }
      return new Promise(function (resolve, reject) {
        if (_this.props.beforeShow) {
          // Don't show loader if beforeShow is really fast
          var handle = setTimeout(function () {
            if (_this.props.beforeShowSpinner) {
              _this.setState({
                loading: true
              });
            }
          }, 100);
          Promise.resolve().then(function () {
            return _this.props.beforeShow();
          }).then(function () {
            clearTimeout(handle);
            _this.setState({
              isOpen: true,
              loading: false
            }, resolve);
          })["catch"](function () {
            clearTimeout(handle);
            _this.setState({
              loading: false
            });
          });
        } else {
          _this.setState({
            isOpen: true
          }, resolve);
        }
      });
    });
    _defineProperty(_this, "_handleClose", function () {
      Promise.resolve(_this.props.beforeClose()).then(function () {
        if (_this.mounted) {
          _this.setState({
            isOpen: false
          });
        }
        if (_this.props.afterClose) {
          _this.props.afterClose();
        }
      })["catch"](function () {});
    });
    _defineProperty(_this, "_afterOpen", function () {
      if (_this.props.afterShow) {
        _this.props.afterShow();
      }
    });
    return _this;
  }
  _inherits(_default, _React$Component);
  return _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var modalStyle = {
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: this.props.onTop ? 2001 : 1050
        },
        content: _objectSpread({}, this.props.contentStyle)
      };
      var sizeClass = '';
      if (this.props.size === 'small') {
        sizeClass = 'modal-sm';
      } else if (this.props.size === 'large') {
        sizeClass = 'modal-lg';
      } else if (this.props.size !== 'normal') {
        modalStyle.content.width = this.props.size;
        modalStyle.content.maxWidth = this.props.size;
      }
      var modalBody = typeof this.props.render === 'function' ? this.props.render({
        closeModal: this.close
      }) : _react["default"].Children.map(this.props.children, function (child) {
        // If it's just dom element (like div) don't pass closeModal
        if (!child || typeof child.type === 'string') {
          return child;
        }
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          closeModal: _this2.close
        });
      });
      var modalClassName = this.props.modalClassName + sizeClass;
      if (!modalClassName.startsWith(defaultModalClassName)) {
        modalClassName = defaultModalClassName + modalClassName;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, this.props.renderTrigger ? this.props.renderTrigger({
        onClick: this._openModal
      }) : /*#__PURE__*/_react["default"].createElement("span", {
        onClick: this._openModal
      }, this.props.trigger), /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
        isOpen: this.state.isOpen,
        className: modalClassName,
        closeTimeoutMS: 150,
        onRequestClose: this._handleClose,
        shouldCloseOnOverlayClick: false,
        style: modalStyle,
        onAfterOpen: this._afterOpen,
        ariaHideApp: false
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-header",
        style: _objectSpread({
          borderRadius: '6px 6px 0 0'
        }, this.props.headerStyle)
      }, /*#__PURE__*/_react["default"].createElement("h4", {
        className: "modal-title"
      }, this.props.title), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn-close",
        onClick: this._handleClose
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-body",
        style: _objectSpread({
          borderRadius: '0 0 6px 6px'
        }, this.props.bodyStyle),
        ref: "body"
      }, modalBody))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(_default, "propTypes", {
  /** Any React component which will trigger the modal on click. <i>e.g.</i> <button>Open Modal</button> */
  trigger: _propTypes["default"].node,
  /** Function which will render trigger. It will get onClick callback as a param. */
  renderTrigger: _propTypes["default"].func,
  /** Function which will render children. It will get closeModal callback as a param. */
  render: _propTypes["default"].func,
  /** If true Modal won't open after clicking on the trigger  */
  triggerDisabled: _propTypes["default"].bool,
  /** Header title */
  title: _propTypes["default"].node,
  /** Width of the modal. Options: "small", "normal", "large"  */
  size: _propTypes["default"].string,
  /** Show modal window on top of everything else on the page. <i>e.g.</i> Over a spinner */
  onTop: _propTypes["default"].bool,
  /** A function that will run before the modal renders. <br> Promises will show a spinner before resolving then show the modal. */
  beforeShow: _propTypes["default"].func,
  /** If false, hide the spinner if beforeShow is taking a while (in case beforeShow is rendering its own)  */
  beforeShowSpinner: _propTypes["default"].bool,
  /** A function that will run after the modal is rendered. */
  afterShow: _propTypes["default"].func,
  /** A function that will run before the modal closes. <br> Promises will cause the modal to remain open until resolved. */
  beforeClose: _propTypes["default"].func,
  /** A function that will run after the modal closes. */
  afterClose: _propTypes["default"].func,
  /** Style of the modal content. */
  contentStyle: _propTypes["default"].object,
  /** Style of the modal header. */
  headerStyle: _propTypes["default"].object,
  /** Style of the modal body. */
  bodyStyle: _propTypes["default"].object,
  children: _propTypes["default"].node,
  /** "Modal__Bootstrap modal-dialog " will be prepended if not there already */
  modalClassName: _propTypes["default"].string
});
_defineProperty(_default, "defaultProps", {
  trigger: '',
  title: '',
  size: 'normal',
  onTop: false,
  beforeShowSpinner: true,
  beforeClose: function beforeClose() {},
  contentStyle: {},
  headerStyle: {},
  bodyStyle: {},
  modalClassName: defaultModalClassName
});